module.exports = __webpack_public_path__ + "static/media/portrait-background.27e9785e.jpg";